import axios from "axios";


export const BACKEND_URL = process.env.NEXT_PUBLIC_BACKEND_URL as string;
// export const BACKEND_URL = "http://localhost:8000/api" as string;


export const handleView = async (fieldId) => {
    try {
        const response = await axios.get(
            `${BACKEND_URL}/adminsetup/admin/courses/assets/preview?key=${encodeURIComponent(fieldId)}`,
            { withCredentials: true }
        );
        return response.data.url || null;
    } catch (error) {
        console.error("Error loading File:", error);
        return null;
    }
};

export const fetchImageUrls = (async (courses,imageCache) => {
    const newCache = new Map(imageCache);
     await Promise.all(
        courses.map(async (course) => {
            if (newCache.has(course.file)) {
                return newCache.get(course.file); // Return cached URL
            }
            if (course.file) {
                const url = await handleView(course.file);
                if (url) newCache.set(course.file, url); // Cache the new URL
                return url;
            }
            return null;
        })
    );
    return newCache // Update cache state

});